// extracted by mini-css-extract-plugin
export default {"attributesLineHeight":"1.8","ScreenLGMin":"(min-width: 1200px)","attributes":"G046bb5","loadingSkeleton":"G9b6115"};